import React, { useState } from 'react'

import ContainerScreen from '@/main/components/shared/containerScreen/containerLayout';
import { withQueryparams } from '@/main/components/core/queryParams/queryparams';
import { PaginationEnum } from '@/main/services/enum/PaginationEnum';
import { getTranslateByKey } from '@/main/services/utils';
import { SearchGridSupplierPerformanceRequest } from '@/main/models/request';
import { SupplierPerformanceReportResponse } from '@/main/models/response';

// COMPONENTS & STYLES LOCAL
import FiltersSupplierPerformance from './filtersSupplierPerformance/filtersSupplierPerformance';
import GridSupplierPerformance from './gridSupplierPerformance/gridSupplierPerformance';
import * as S from './styles';

function SupplierPerformanceScreen() {
  const [dataGrid, setDataGrid] = useState<SupplierPerformanceReportResponse[]>([])
  const [formFilters, setFormFilters] = useState<SearchGridSupplierPerformanceRequest | null>(null)

  function onResetSearch() {
    setDataGrid([]);
    setFormFilters(null);
  }

  async function getDataGrid(filters: SearchGridSupplierPerformanceRequest | Partial<SearchGridSupplierPerformanceRequest> = {}, isResetSearch: boolean = true) {
    const request: SearchGridSupplierPerformanceRequest = {
      ...(isResetSearch ? {} : formFilters),
      ...filters as SearchGridSupplierPerformanceRequest,
      pageIndex: PaginationEnum.PageIndexIntial,
      pageSize: PaginationEnum.PageSize30,
    };

    onResetSearch()
    setFormFilters(request);
  }

  const titlePage = `${getTranslateByKey('module.report')} > ${getTranslateByKey('screen.suppPerformanceReport')}`
  return (
    <ContainerScreen title={titlePage}>
      <FiltersSupplierPerformance
        formFilters={formFilters}
        getDataGrid={getDataGrid}
        onResetSearch={onResetSearch}
      />
      <GridSupplierPerformance
        formFilters={formFilters}
        dataGrid={dataGrid}
        setDataGrid={setDataGrid}
      />
    </ContainerScreen>
  )
}

export default withQueryparams(SupplierPerformanceScreen)